// extracted by mini-css-extract-plugin
module.exports = {"bar":"Topbar_bar__v72ih","time":"Topbar_time__1FczJ"};